import "../../../../css/all.less";
import React from "react";
import { Routes, Route } from "react-router-dom";
import ErrorPageRoot from "../ErrorPageRoot/ErrorPageRoot";

const ErrorRoutes: React.FC = () => (
    <Routes>
        <Route path="*" element={<ErrorPageRoot />} />
    </Routes>
);

export default ErrorRoutes;
